import React, { useEffect } from 'react';

import '../../assets/styles/About.css';
import { scrollToNavigation } from '../../utils/utils';

const IslamicIndices = () => {
    useEffect(() => {
        document.title = 'Islamic Indices » Askimam';
    }, []);

    scrollToNavigation();

    return (
        <div>
            <h2 className="page-title">Islamic Financial Indices</h2>
            <div className="content">
                <h5>YOUR BRIEF GUIDE TO ISLAMIC FINANCIAL INDICES</h5>
                <p>
                    <strong>MAHR: </strong>or dowry is one of the rights of the wife; a mandatory payment; in the form
                    of money or possessions paid by the groom, to the bride at the time of Nikah (marriage). While
                    the Mahr is often money, it can also be anything agreed upon by the bride such as jewellery,
                    furniture etc.
                </p>
                <p><strong>MINIMUM MAHR: </strong>The minimum amount of Mahr according to the Hanafi Madh-hab is 10 dirhams*
                    [30.618 grams of silver]. Mahr lesser than 10 dirhams cannot be stipulated. [Hakim; Fathul Qadeer]
                </p>
                <p><strong>MAHR FATIMI: </strong>The amount given as Mahr to Hadhrat Fatima Radhiyallahu Anha –
                    daughter of Nabi<span> ﷺ </span>by Hadhrat Ali Radhiyallahu Anhu which was 480 dirhams
                    [1469.664 grams of silver].  [Maj’mauz-Zawaid]
                </p>

                <p><strong>MAHR AZWAJ-AN NABI</strong><span> ﷺ:</span> The amount given as Mahr by Rasulullah<span> ﷺ</span>
                    to his wives which was 500 dirhams [1530.9 grams of silver]. [Muslim]
                </p>
                <p><strong>GOLD AND SILVER NISAB: </strong> The Nisab* of gold and silver is 20 mithqals and 200 dirhams respectively.
                    The Nisab of gold is 87.48 grams and silver is 612.36 grams.
                    * Nisab is a threshold / minimum amount when an individual possesses it for one lunar year, Zakaat becomes obligatory.
                    The amount of Nisab is having:
                </p>
                <ol>
                    <li>612.36 grams of silver or 87.48 grams of gold or</li>
                    <li>any value in cash equivalent to 612.36 g of silver</li>
                    <li>or stock in trade equivalent to 612.36 g of silver</li>
                    <li>or having some or all of the above whose total value reaches the value of 612.36 grams of silver.</li>
                </ol>
                <p>➔ All which are in excess of one’s basic necessities and liabilities. [Badaai-us-Sanaai’; V. 2, Pg. 402- DKI]</p>
                <p><strong>GOLD AND SILVER PRICES: </strong></p>
                <p>The Gold and Silver prices are shown to help you calculate Zakat on jewellery.</p>
                <p>Zakaat on personal jewellery : One should first determine the carat of the gold / silver,
                    thereafter one should weigh the jewellery in hand and thereafter ascertain the current
                    scrap value / price per gram of the carat. Once the value of the jewellery has been
                    established, 2.5% of the value should be given in Zakaat.
                </p>
                <p>➔ [number of grams x current price of carat per gram = Total value |</p>
                <p>2.5% of total value = Zakaat.</p>
            </div>
        </div>
    );
};


export default IslamicIndices;
